<template>
    <div class="user-focus" @click="onClick">
        <Tooltip placement="bottom" :title="user.focus_status ? '取消关注' : ''">
            <slot name="focused" v-if="user.focus_status"></slot>
            <slot name="unFocused" v-else></slot>
        </Tooltip>
    </div>
</template>

<script setup lang="ts">
import http from "@/utils/http";
import {getCurrentInstance, ref} from "vue";
import {route} from "@/utils/common";
import {User} from "../../../env";
import {Tooltip} from "ant-design-vue";

const emits = defineEmits(['change'])
const ins = getCurrentInstance()
const props = defineProps<{
    user: User,
}>()

const user = ref(props.user)

const onClick = async (e: Event) => {
    e.stopPropagation()
    e.preventDefault()
    if (user.value.focus_status) {
        await http.delete(route('api.user.focus.delete', {user: props.user.id}));
        user.value.focus_status = false
    } else {
        await http.post(route('api.user.focus', {user: props.user.id}))
        user.value.focus_status = true
    }
    emits('change')
}
</script>

<style scoped lang="less">
.user-focus {
    cursor: pointer;
}
</style>
